import _ from 'lodash';
import SocketIOClient from 'socket.io-client';

import config from '../config/configureEnv';
import i18n from '../config/i18n';
import { getUserAuthDataFromLocalStorage } from '../utils';
import {
  NEW_MSG,
  ACK_MSG,
  UPDATE_CHANNEL_TITLE,
  NEW_CHANNEL_MEMBER,
  DELETE_CHANNEL_MEMBER,
  AUTHENTICATION,
  AUTHENTICATED,
  UNAUTHENTICATED,
  ERROR,
} from '../constants/WebsocketEventTypes';

export default class WebSocket {
  constructor() {
    this.socket = null;
    this.actions = null;
  }

  getWebSocketUrl = apiUrl => _.split(apiUrl, /\/api\//, 2);

  connect = () => {
    const [host, apiVersion] = this.getWebSocketUrl(config.bocaAPIUrl);
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    this.socket = SocketIOClient(host, {
      path: `/api/${apiVersion}/ws`,
      reconnectionAttempts: 10,
      reconnectionDelay: 3000,
      reconnectionDelayMax: 30000,
    });
    this.socket.emit(AUTHENTICATION, { tokenId: accessToken });

    this.socket.on(UNAUTHENTICATED, (err) => {
      if (this.actions) {
        this.actions.createDangerAlert(err.message);
      }
      this.socket.close();
    });

    this.socket.on(AUTHENTICATED, () => {
      this.socket.on(NEW_MSG, this.newMsgHandler);
      this.socket.on(ACK_MSG, this.receiveAckMsgHandler);
      this.socket.on(UPDATE_CHANNEL_TITLE, this.updatedChannelTitleHandler);
      this.socket.on(NEW_CHANNEL_MEMBER, this.newChannelMemberHandler);
      this.socket.on(DELETE_CHANNEL_MEMBER, this.deleteChannelMemberHandler);
    });
    this.socket.on(ERROR, this.errorHandler);
  };

  errorHandler = (msg) => {
    this.actions.createDangerAlert(msg);
  };

  newMsgHandler = (newMsg) => {
    this.actions.websocketReceiveNewMessage(newMsg);
  };

  receiveAckMsgHandler = (ackUserInfo) => {
    this.actions.websocketReceiveAckMessage(ackUserInfo);
  };

  sendAckMsg = (channelId, userId) => {
    this.socket.emit(ACK_MSG, { channelId, userId });
  };

  updatedChannelTitleHandler = (updatedChannel) => {
    this.actions.websocketReceiveUpdateTitle(updatedChannel);
  };

  newChannelMemberHandler = (newChannelMember) => {
    this.actions.websocketReceiveNewMember(newChannelMember);
  };

  deleteChannelMemberHandler = (member) => {
    this.actions.websocketReceiveDeletedMember(member);
  };

  disconnect = () => {
    if (this.socket) {
      this.socket.close();
    } else {
      throw new Error(i18n.t('noWebsocketTobeClosed'));
    }
  };

  setActions = (actions) => {
    this.actions = actions;
  }
}



// WEBPACK FOOTER //
// ./src/websocket/WebSocket.js